import {MNullable} from '../../Toolkit/Utils';

export class Contact {
    public id: number = 0;
    public crewId: number = 0;
    public description: string = '';
    public contactType: number = 0;
    public contact: string = '';
};

export class ContactReply {
    public crewContact: MNullable<Contact> = null;
};

export class ContactMultiReply {
    public crewContacts: Contact[] = [];
};

export class ContactDeleteReply {
    public deleteCount: number = 0;
};